export default __webpack_public_path__ + "static/media/deal-5.e50510b0.webp";